import { Link } from "react-router-dom";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionTitle({
  eyebrow,
  title,
  desc,
  linkTo,
  linkLabel,
}: SectionTitleProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="text-xs tracking-[0.3em] text-primary-600 mb-3">{eyebrow}</p>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
          {title}
        </h2>
        {desc && (
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-3">
            {desc}
          </p>
        )}
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-600 transition-colors whitespace-nowrap shrink-0"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}